import React, { useState } from "react";
import { Button, Modal } from "antd";

import s from "./CostumeSelector.module.scss";

const CostumeSelector = ({
    type,
    currentPlayer,
    userData,
    setProfile,
    maxCostumeValue,
}) => {
    const [showModal, setShowModal] = useState(false);
    let profileDataKey;

    if (currentPlayer === 1) {
        profileDataKey = "profile_p1";
    } else {
        profileDataKey = "profile_p2";
    }

    const costumeData = userData[profileDataKey].userCostume;

    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    const title = capitalizeFirstLetter(type);

    const resetCostume = (type) => {
        let profileObject = {
            ...userData[profileDataKey],
        };

        profileObject.userCostume[type] = 0;

        setProfile(profileObject, currentPlayer);
    };

    const setCostume = (type, value) => {
        let profileObject = {
            ...userData[profileDataKey],
        };

        profileObject.userCostume[type] = value;

        setProfile(profileObject, currentPlayer);
        setShowModal(false);
    };

    return (
        <div
            style={{
                margin: `0 8px 16px`,
                flex: `0 0 200px`,
            }}
        >
            <span
                style={{
                    display: `block`,
                    marginRight: `16px`,
                    fontWeight: `600`,
                    marginBottom: `4px`,
                }}
            >{`${title}:`}</span>
            <div
                style={{
                    backgroundColor: `#ddd`,
                    backgroundImage: `url('/assets/costumes/${type}/${type}_${costumeData[type]}.png')`,
                    backgroundSize: `cover`,
                    backgroundPosition: `center`,
                    width: `100%`,
                    aspectRatio: `10/9`,
                }}
            />

            <Button
                type="primary"
                style={{
                    marginTop: `8px`,
                    width: `100%`,
                }}
                onClick={() => {
                    setShowModal(true);
                }}
            >{`Change ${title}...`}</Button>

            <Button
                type="secondary"
                style={{
                    marginTop: `8px`,
                    width: `100%`,
                }}
                onClick={() => resetCostume(type)}
            >{`Reset`}</Button>

            <Modal
                title={`Change ${title}`}
                visible={showModal}
                destroyOnClose={false}
                maskClosable={true}
                width={`85%`}
                footer={null}
                onOk={() => {
                    setShowModal(false);
                }}
                onCancel={() => {
                    setShowModal(false);
                }}
            >
                <div
                    style={{
                        display: `flex`,
                        flexWrap: `wrap`,
                        width: `100%`,
                        maxHeight: `75vh`,
                        overflow: `auto`,
                        justifyContent: `center`,
                    }}
                >
                    {
                        // create buttons for each costume value
                        Array.from(Array(maxCostumeValue).keys()).map((value) =>
                            value !== 0 ? (
                                <button
                                    key={value}
                                    type="primary"
                                    style={{
                                        flex: `0 1 200px`,
                                        padding: 0,
                                        border: 0,
                                        backgroundColor: `transparent`,
                                        cursor: `pointer`,
                                    }}
                                    onClick={() => setCostume(type, value)}
                                >
                                    <img
                                        src={`/assets/costumes/${type}/${type}_${value}.png`}
                                        className={s.costumeImage}
                                        alt={`${type} ${value}`}
                                    />
                                </button>
                            ) : null
                        )
                    }
                </div>
            </Modal>
        </div>
    );
};

export default CostumeSelector;
